export enum NavItemCodes {
    MANAGEMENT = 'MANAGEMENT',
    HOME = 'HOME',
    START = 'START',

    // Localization
    LOCALIZATION_ACTIVATE = 'LOCALIZATION_ACTIVATE',
    LOCALIZATION_ADD = 'LOCALIZATION_ADD',
    LOCALIZATION_DEACTIVATE = 'LOCALIZATION_DEACTIVATE',
    LOCALIZATION_EDIT = 'LOCALIZATION_EDIT',
    LOCALIZATION_MANAGEMENT = 'LOCALIZATION_MANAGEMENT',
    LOCALIZATION_MANAGEMENT_LIMITED = 'LOCALIZATION_MANAGEMENT_LIMITED',

    // Partner
    PARTNER_ACTIVATE = 'PARTNER_ACTIVATE',
    PARTNER_ADD = 'PARTNER_ADD',
    PARTNER_DEACTIVATE = 'PARTNER_DEACTIVATE',
    PARTNER_DEACTIVATE_SALES = 'PARTNER_DEACTIVATE_SALES',
    PARTNER_EDIT = 'PARTNER_EDIT',
    PARTNER_MANAGEMENT = 'PARTNER_MANAGEMENT',

    // User
    USER_ACTIVATE = 'USER_ACTIVATE',
    USER_ADD = 'USER_ADD',
    USER_DEACTIVATE = 'USER_DEACTIVATE',
    USER_EDIT = 'USER_EDIT',
    USER_PASS_RESET = 'USER_PASS_RESET',
    USER_MANAGEMENT = 'USER_MANAGEMENT',
    USER_LIST_DOWNLOAD = 'USER_LIST_DOWNLOAD',

    // Password Policy
    PASSWORD_POLICY_ADD = 'PASSWORD_POLICY_ADD',
    PASSWORD_POLICY_EDIT = 'PASSWORD_POLICY_EDIT',
    PASSWORD_POLICY_DELETE = 'PASSWORD_POLICY_DELETE',
    PASSWORD_POLICY_MANAGEMENT = 'PASSWORD_POLICY_MANAGEMENT',

    // Product
    PRODUCT_MANAGEMENT = 'PRODUCT_MANAGEMENT',
    PRODUCT_ADD = 'PRODUCT_ADD',
    PRODUCT_PG_DUPLICATE = 'PRODUCT_PG_DUPLICATE',
    PRODUCT_PG_EDIT = 'PRODUCT_PG_EDIT',
    PRODUCT_CPI_EDIT = 'PRODUCT_CPI_EDIT',
    PRODUCT_CPI_DUPLICATE = 'PRODUCT_CPI_DUPLICATE',

    // Config
    CONFIGURATION = 'CONFIGURATION',
    TARIFF_ELEMENTS = 'TARIFF_ELEMENTS',
    BRANDS = 'BRANDS',
    BRANDS_DELETE = 'BRANDS_DELETE',

    // Reports
    REPORTS_LIST = 'REPORTS_LIST',
    REPORT_VIEW = 'REPORT_VIEW',

    // Policy
    POLICY_ADD = 'POLICY_ADD',
    POLICY_REGISTRY = 'POLICY_REGISTRY',
    POLICY_PREVIEW = 'POLICY_PREVIEW',
    POLICY_PG = 'POLICY_PG',
    POLICY_LABEL_SHORT = 'POLICY_LABEL_SHORT',

    // CPI
    SALES_CPI_PRODUCT_PICK = 'SALES_CPI_PRODUCT_PICK',
    SALES_CPI_OFFER_QUESTIONNAIRE = 'SALES_CPI_OFFER_QUESTIONNAIRE',
    SALES_CPI_OFFER_SIMULATE = 'SALES_CPI_OFFER_SIMULATE',
    SALES_CPI_OFFER_DATA = 'SALES_CPI_OFFER_DATA',
    POLICY_CPI = 'POLICY_CPI',

    // Tariff
    TARIFF = 'TARIFF',

    // Documents
    DOCUMENT_ADD = 'DOCUMENT_ADD',
    DOCUMENT_DELETE = 'DOCUMENT_DELETE',
    DOCUMENT_EDIT = 'DOCUMENT_EDIT',
    DOCUMENT_DOWNLOAD = 'DOCUMENT_DOWNLOAD',
    DOCUMENT_VIEW = 'DOCUMENT_VIEW',
    DOCUMENT_MANAGEMENT = 'DOCUMENT_MANAGEMENT',

    // CoAcquisition
    CO_ACQUISITION_CONFIGURATION = 'CO_ACQUISITION_CONFIGURATION',
    CO_ACQUISITION_ADD = 'CO_ACQUISITION_ADD',
    CO_ACQUISITION_EDIT = 'CO_ACQUISITION_EDIT',
    CO_ACQUISITION_DELETE = 'CO_ACQUISITION_DELETE',

    // Transcoder
    TRANSCODER_CONFIGURATION = 'TRANSCODER_CONFIGURATION',
    TRANSCODER_ADD = 'TRANSCODER_ADD',
    TRANSCODER_EDIT = 'TRANSCODER_EDIT',
    TRANSCODER_DELETE = 'TRANSCODER_DELETE',
    TRANSCODER_FORM_ADD = 'TRANSCODER_FORM_ADD',
    TRANSCODER_FORM_EDIT = 'TRANSCODER_FORM_EDIT',

    // Export xml
    EXPORT_XML = 'EXPORT_XML',

    // Migrated Policies
    MIGRATED_POLICIES = 'MIGRATED_POLICIES',
    MIGRATED_POLICIES_LABEL_SHORT = 'MIGRATED_POLICIES_LABEL_SHORT',
    MIGRATED_POLICIES_VIEW = 'MIGRATED_POLICIES_VIEW',

    // Repository Policies
    REPOSITORY = 'REPOSITORY',
    REPOSITORY_LABEL_SHORT = 'REPOSITORY_LABEL_SHORT',
    REPOSITORY_LABEL_BROKEN = 'REPOSITORY_LABEL_BROKEN',
    REPOSITORY_POLICY = 'REPOSITORY_POLICY',
    REPOSITORY_POLICY_BREADCRUMB = 'REPOSITORY_POLICY_BREADCRUMB',
}
